import Vue from 'vue'
import TabelaComponent from './TabelaComponent'
import ErrosBox from './ErrosBoxComponent'
import ButtonSpinner from './ButtonSpinner'
import LoadingComponent from './LoadingComponent'
import LoadingFullComponent from './LoadingFullComponent'
import StatusComponent from './StatusComponent'
import BtnVoltar from './BtnVoltar'
import TempoSessao from './TempoSessao'
import DetalheComponent from './DetalheComponent'
import DetalheComponent2 from './DetalheComponent2'
import DetalheComponent3 from './DetalheComponent3'
import DetalheComponent4 from './DetalheComponent4'
import BoxComponent from './BoxComponent'
import AnoComponent from './AnoComponent'

Vue.component('AppTabela', TabelaComponent)
Vue.component('AppErrosBox', ErrosBox)
Vue.component('AppBtnSpinner', ButtonSpinner)
Vue.component('AppLoading', LoadingComponent)
Vue.component('AppLoadingFull', LoadingFullComponent)
Vue.component('AppStatus', StatusComponent)
Vue.component('AppBtnVoltar', BtnVoltar)
Vue.component('AppTempoSessao', TempoSessao)
Vue.component('AppDetalhe', DetalheComponent)
Vue.component('AppDetalhe2', DetalheComponent2)
Vue.component('AppAno', AnoComponent)
Vue.component('AppKV', DetalheComponent3)
Vue.component('AppBox', BoxComponent)
Vue.component('Detalhe', DetalheComponent4)
